import React from 'react';
import { Link } from 'react-router-dom';
import PricingSection from '../components/home/PricingSection';

const PricingPage = () => {
  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <h1 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center">
          Membership Plans
        </h1>
      </div>
      <PricingSection />
    </div>
  );
};

export default PricingPage;
